import { PublicClientApplication, AccountInfo } from "@azure/msal-browser";
import { jwtDecode } from "jwt-decode";

export const refreshAdminToken = async (
  msalInstance: PublicClientApplication,
): Promise<string | null> => {
  const token = localStorage.getItem("token");

  if (!token) return null;

  const decodedToken: any = jwtDecode(token);
  const isAdmin = decodedToken.roles?.includes("Admin");

  if (!isAdmin) {
    localStorage.clear();
    window.location.href = "/login";
    throw new Error(
      "Token expired and user is not an admin. Redirecting to login.",
    );
  }

  if (decodedToken.exp * 1000 > Date.now()) {
    return token;
  }

  try {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      throw new Error("No accounts found for silent token renewal.");
    }

    const refreshResponse = await msalInstance.acquireTokenSilent({
      scopes: ["user.read"],
      account: accounts[0] as AccountInfo,
      forceRefresh: true,
    });

    localStorage.setItem("token", refreshResponse.idToken);
    return refreshResponse.idToken;
  } catch (error) {
    console.error("Silent token renewal failed:", error);
    localStorage.clear();
    window.location.href = "/login";
    throw new Error("Silent renewal failed: Redirecting to login");
  }
};
